export default {

    GetCustomersListToUpdateUDFs(membershipPackage, membershipTypesUDFs, customerResponse) {
        let CustomerUDFsCollection = [];

        membershipPackage.forEach(memPack => {

            memPack.MembershipProducts.forEach(memType => {

                if (memType.MembershipType === "Membership" && memType.Users && memType.Users.length > 0) {

                    memType.Users.forEach(u => {
                        CustomerUDFsCollection.push(this.GenerateCustomerUDFs(memType.MembershipTypeID, u, membershipTypesUDFs, customerResponse));
                    });
                }
            })
        });

        return CustomerUDFsCollection;
    },
    GenerateCustomerUDFs(memTypeID, user, membershipTypesUDFs, customerResponse) {
        let customerUdfObj = {};
        customerUdfObj.CustomerID = 0;
        customerUdfObj.CustomerUDFs = [];

        //Update Customer ID
        if (customerResponse && customerResponse.length > 0) {
            if (user.firstName == customerResponse[0].FirstName && user.lastName == customerResponse[0].LastName) {
                customerUdfObj.CustomerID = customerResponse[0].CustomerID;
            }
            else {
                customerResponse[0].LinkedIndividuals.map(u => {

                    if (user.firstName == u.FirstName && user.lastName == u.LastName) {
                        customerUdfObj.CustomerID = u.CustomerID;
                    }
                });
            }
        }

        if (membershipTypesUDFs.filter(x => x.MembershipTypeID === memTypeID).length > 0 && membershipTypesUDFs.filter(x => x.MembershipTypeID === memTypeID)[0].UDFCategories != null) {
            membershipTypesUDFs.filter(x => x.MembershipTypeID === memTypeID)[0].UDFCategories.map((udfCategorey, i) => {

                udfCategorey.UserDefinedFields.map((udf) => {

                    if (udf.hasOwnProperty('Users') && udf.Users.filter(x => x.userID == user.userNo).length > 0) {
                        let udfUser = udf.Users.filter(x => x.userID == user.userNo)[0];
                        let udfObj = {
                            "UDFName": udf.UDFName,
                            "UDFType": udf.UDFType,
                            "UDFValue": udfUser.userUDFValue
                        }

                        customerUdfObj.CustomerUDFs.push(udfObj);
                    }
                })
            });
        }

        return customerUdfObj;
    },
    UpdateMembershipUDFsWithCustomerUDFValue(membershipPackage, membershipTypesUDFs, customerUdfs) {

        let aa = 0;

        if (membershipPackage.MembershipProducts && membershipPackage.MembershipProducts.length > 0) {

            membershipPackage.MembershipProducts.forEach(memType => {

                if (memType.MembershipType === "Membership" && memType.Users.length > 0) {

                    let memTypeUdfs = this.GetMembrshipTypeUDF(memType.MembershipTypeID, membershipTypesUDFs);

                    if (memTypeUdfs) {
                        memType.Users.forEach(u => {

                            let customerUDF = this.GetCustomerUDF(u.userNo, customerUdfs);

                            memTypeUdfs.UDFCategories.forEach(udfCategorey => {

                                udfCategorey.UserDefinedFields.forEach(udf => {

                                    if (customerUDF) {
                                        let val = this.GetCustomerUDFValue(customerUDF, udf);

                                        if (val) {
                                            let usr = { userID: u.userNo, userUDFValue: val };
                                            udf.Users.push(usr);
                                        }
                                    }
                                })
                            });

                        });

                        membershipTypesUDFs = membershipTypesUDFs.filter(x => x.MembershipTypeID !== memType.MembershipTypeID);
                        membershipTypesUDFs.push(memTypeUdfs);
                    }
                }
            });
        }

        return membershipTypesUDFs;
    },
    GetMembrshipTypeUDF(membershipTypeID, membershipTypesUDFs) {

        let memTypeUDFs = null;

        if (membershipTypesUDFs && membershipTypesUDFs.length > 0 && membershipTypesUDFs.filter(x => x.MembershipTypeID === membershipTypeID).length > 0) {
            memTypeUDFs = membershipTypesUDFs.filter(x => x.MembershipTypeID === membershipTypeID)[0];
        }

        return memTypeUDFs;
    },
    GetCustomerUDF(customerNo, customerUdfs) {
        let cstUdfs = null;

        if (customerUdfs && customerUdfs.length > 0 && customerUdfs.filter(x => x.CustomerID === customerNo).length > 0) {
            cstUdfs = customerUdfs.filter(x => x.CustomerID === customerNo)[0];
        }

        return cstUdfs;
    },
    GetCustomerUDFValue(cstUDFs, UDF) {

        let value = null;

        if (cstUDFs.CustomerUDFs && cstUDFs.CustomerUDFs.filter(x => x.UDFCategoryName === UDF.UDFCategoryName && x.UDFName === UDF.UDFName && x.UDFType === UDF.UDFType).length > 0) {
            value = cstUDFs.CustomerUDFs.filter(x => x.UDFCategoryName === UDF.UDFCategoryName && x.UDFName === UDF.UDFName && x.UDFType === UDF.UDFType)[0].UDFValue;
        }

        return value;
    }
}






